import { render } from "./App.vue?vue&type=template&id=4f06e926"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@/style.css?vue&type=style&index=0&lang=css"

import exportComponent from "/home/sls/Documents/dev/intervallX/intx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__